import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { getHostUrl } from '../../../store/apiWrapper';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import NoDataComponent from '../../common/noDataComponent';

import './industryAnalysis.scss';

class IndustryAnalysisMethodology extends React.Component {
    render() {
        const year = parseInt(this.props.year);
        if (isNaN(year) || isNullOrUndefined(this.props.isNace))
            return (<NoDataComponent />);

        const methodologyText = this.props.isNace
            ? this.props.translate('IndustryAnalysis.Methodology.MainTextNACE')
            : this.props.translate('IndustryAnalysis.Methodology.MainTextOKEC');

        return (
            <>
                {this.renderTitle(year)}
                <div className="methodology-text">{ReactHtmlParser(methodologyText)}</div>
                <br />
                <div className="print-hidden">
                    {
                        [
                            { show: true, name: "sposob.pdf", translate: "IndustryAnalysis.Methodology.ModeProcessingTechnique" },
                            { show: true, name: "charak_pu.pdf", translate: "IndustryAnalysis.Methodology.CharacterizationFinancialRatios" },
                            { show: year < 2014, name: "charak_su.pdf", translate: "IndustryAnalysis.Methodology.CharacterizationStructuralIndicators" },
                            { show: true, name: "defvym.pdf", translate: "IndustryAnalysis.Methodology.DefinitionDeterminationIndicators" },
                            { show: this.props.isNace, name: "nace_ciselnik.pdf", translate: "IndustryAnalysis.Methodology.FullCodeBookNACE" },
                            { show: !this.props.isNace, name: "okec_ciselnik.pdf", translate: "IndustryAnalysis.Methodology.FullCodeBookOKEC" }
                        ].map((document, i) => (
                            document.show && <>
                                <a key={`document-${i}`} className="link-internal" href={`${getHostUrl()}/files/industry-analysis/${year}/${document.name}`} target="_blank">
                                    <Translate id={document.translate} /> ({year})
                                </a>
                                <br />
                            </>
                        ))}
                </div >
            </>
        )
    }

    renderTitle = (year) => {
        return (
            <span className="underlined-title-wrapper underlined-title-wrapper-margin-bottom">
                <h5 className="underlined-title rb-header">
                    {<Translate id="IndustryAnalysis.Methodology.MainTextTitle" options={{ renderInnerHtml: true }} />}
                    {` (${year})`}
                </h5>
            </span>
        );
    }
}

export default withLocalize(connect(
    state => ({ language: state.userContext.language }),
)(IndustryAnalysisMethodology));
